import { useEffect, useRef, useState } from 'react';

export function useRafWindowSize() {
	const raf = useRef(null);
	const [size, setSize] = useState(() => ({
		width: window.innerWidth,
		height: window.innerHeight,
	}));
	useEffect(() => {
		const onResize = () => {
			if (raf.current == null) {
				raf.current = requestAnimationFrame(() => {
					raf.current = null;
					setSize({ width: window.innerWidth, height: window.innerHeight });
				});
			}
		};
		window.addEventListener('resize', onResize, { passive: true });
		return () => {
			if (raf.current != null) cancelAnimationFrame(raf.current);
			window.removeEventListener('resize', onResize);
		};
	}, []);
	return size;
}

export function useElementContentSize() {
	const ref = useRef(null);
	const raf = useRef(null);
	const [box, setBox] = useState({ width: 0, height: 0 });

	useEffect(() => {
		if (!ref.current) return;
		const el = ref.current;
		const ro = new ResizeObserver((entries) => {
			const entry = entries[0];
			if (!entry) return;
			if (raf.current != null) cancelAnimationFrame(raf.current);
			raf.current = requestAnimationFrame(() => {
				raf.current = null;
				const size = entry.contentBoxSize?.[0] ?? entry.contentBoxSize;
				if (size && typeof size.inlineSize === 'number') {
					setBox({
						width: size.inlineSize,
						height: size.blockSize ?? el.clientHeight,
					});
				} else {
					setBox({ width: el.clientWidth, height: el.clientHeight });
				}
			});
		});
		ro.observe(el);
		return () => {
			if (raf.current != null) cancelAnimationFrame(raf.current);
			ro.disconnect();
		};
	}, []);

	return { ref, ...box };
}
